import Placeholder from './Placeholder';
import messages from './i18n/index';
import EditorPage from './editors/EditorPage';

export { messages, EditorPage };
export default Placeholder;
